import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, Input, Select } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { data4_1_2 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import FileSaver from "file-saver";
import TableText from "../../TableText";
import getJson, { numConvert } from '../../../../method';
const { Option } = Select;
const { TextArea } = Input;

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('Q'),
            year: moment().subtract(1, 'month').format('YYYY'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            dateData: []
        }
    }

    componentDidMount() {
        let year = Number(this.state.year || "0");
        let dateData = [];
        let len = year - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getDateData(this.state.date);
    }

    onChange = (name, value, i) => {
        let data = [...this.state.data];
        data[i][name] = value;
        data.forEach((item, index) => {
            if (index < (data.length - 1)) {
                data[index]['total'] = ['first', 'second', 'third'].reduce((a, b) => {
                    return a += numConvert(data[index][b]);
                }, 0).toFixed(2);
            }
        });
        ['target', 'total', 'first', 'second', 'third'].forEach(name => {
            data[data.length - 1][name] = data.reduce((a, b, index) => index >= (data.length - 1) ? a : a += numConvert(b[name]), 0).toFixed(2);
        });

        this.setState({ data });
    }

    getDateData = (date, isLastMonth) => {
        const dataBegin = JSON.stringify(data4_1_2);
        let data = JSON.parse(dataBegin);
        const year = this.state.year;
        if (isLastMonth) {
            date = date - 1 > 0 ? date - 1 : 1;
            if (this.state.data.some(x => x.id)) return message.error('当月数据已存在，无法填充！');
            this.setState({ data: [], loading: true });
        }
        fetch(`/_4_1_2_info?quarter=${date}&year=${year}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            if (isLastMonth) {
                data = data.map(x => { delete x.id; return x });
            }
            this.setState({
                data: data,
                loading: false
            })
        }).catch(err => {
            this.setState({ loading: false })
            console.error(err)
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        let year = this.state.year;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }

        let data = this.state.data.map((x, i) => ({ ...x, quarter: date, year }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_1_2', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_1_2', 1.5, '4.12', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} Sales Selling Strategy & Action Plan`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }
    // 导出酒店保存情况
    downloadSave = async () => {
        try {
            const { date } = this.state;
            const res = await fetch(`/saveExcelActionPlan?quarter=${date}`, { credentials: 'include' });
            const blob = await res.blob();
            let file = new Blob([blob], { type: "" });
            FileSaver.saveAs(file, `Sales Selling Strategy & Action Plan 第${date}季度.xls`);
            this.setState({ loading: false });
        } catch (error) {
            message.error('导出失败！');
            this.setState({ loading: false });
        }
    }
    render() {
        const { data, date, print, loading, dateData, year } = this.state;
        const len = data.length - 1;
        const totalData = [];
        const columns = [{
            title: <div>No.<br />序号</div>,
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 50,
            render: (text, record, index) => {
                if (index == (data.length - 1)) {
                    return {
                        props: {
                            colSpan: 4,
                        },
                        children: <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "right" }}>
                            {record.name}
                        </div>
                    }
                }
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {index + 1}
                    </div>
                )
            }
        }, {
            title: <div>Market Segment<br />细分市场</div>,
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            width: 200,
            render: (text, record, index) => {
                if (index == (data.length - 1)) {
                    return {
                        props: {
                            colSpan: 0,
                        },
                    }
                }
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>Key Strategy <br />主要策略</div>,
            dataIndex: 'strategy',
            key: 'strategy',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                if (index == (data.length - 1)) {
                    return {
                        props: {
                            colSpan: 0,
                        },
                    }
                }
                return <div className="table-padding table-color-number">
                    {print ? text : <TextArea
                        autosize={{ minRows: 4 }}
                        defaultValue={text}
                        onBlur={(e) => {
                            let value = e.target.value || "";
                            this.onChange('strategy', value, index)
                        }}
                    />}
                </div>
            }
        }, {
            title: <div>Action Plans<br />行动计划</div>,
            dataIndex: 'plans',
            key: 'plans',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                if (index == (data.length - 1)) {
                    return {
                        props: {
                            colSpan: 0,
                        },
                    }
                }
                return <div className="table-padding table-color-number">
                    {print ? text : <TextArea
                        autosize={{ minRows: 4 }}
                        defaultValue={text}
                        onBlur={(e) => {
                            let value = e.target.value || "";
                            this.onChange('plans', value, index)
                        }}
                    />}
                </div>
            }
        }, {
            title: <div>Target Room Nts <br />目标间夜 {date * 3 - 2}-{date * 3}月份</div>,
            dataIndex: 'target',
            key: 'target',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: print || len == index ? 'number' : 'inputNumber',
                    name: "target",
                    onChange: this.onChange,
                    totalIndex: totalData,
                };
                return <TableText data={props} />
            }
        }, {
            title: <div>Result  Room Nts <br />完成间夜</div>,
            align: "center",
            children: [{
                title: `${date * 3 - 2}月`,
                dataIndex: 'first',
                key: 'first',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: print || len == index ? 'number' : 'inputNumber',
                        name: "first",
                        onChange: this.onChange,
                        totalIndex: totalData,
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${date * 3 - 1}月`,
                dataIndex: 'second',
                key: 'second',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: print || len == index ? 'number' : 'inputNumber',
                        name: "second",
                        onChange: this.onChange,
                        totalIndex: totalData,
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${date * 3}月`,
                dataIndex: 'third',
                key: 'third',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: print || len == index ? 'number' : 'inputNumber',
                        name: "third",
                        onChange: this.onChange,
                        totalIndex: totalData,
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `Total`,
                dataIndex: 'total',
                key: 'total',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "total",
                        onChange: this.onChange,
                        totalIndex: totalData,
                    };
                    return <TableText data={props} />
                }
            }]
        }]
        return (
            <div className="table table2_1">
                <Row className="title" id="table4_1_2" style={{ width: this.state.print ? 2475 : 'auto' }}>
                    <Row>4.1.2 Sales Selling Strategy & Action Plan 销售策略和行动计划</Row>
                    <Row style={{ fontSize: 14, margin: "10px 0" }}>
                        1.  每月第一周内提交包含当月的季度报表，季度最后一月需提交当季度和次季度两份
                        <br />
                        2.  报表中的填写栏的解释
                        <br />
                        （1）“主要策略”“行动计划”：对于同一季度报表，于每月第一周内提交的这两栏内容基本不变，若有需要酒店也可在原填写内容的基础上新增
                        <br />
                        （2）“目标间夜”：基于酒店每月Budget相加总和进行制定，以完成Budget为目标，制定的目标间夜可有两种方向：（a）等同于Budget，或（b）等同于ES4.1中的Forecast。
                        <br />
                        （3）“完成间夜Result Night”：指的是每月截止到提交此报表时酒店PMS系统中对应月份的On-Book间夜数据。
                    </Row>
                    <Row className="table-month">
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120, marginRight: 10 }}
                            value={year}
                            onChange={(str) => {
                                this.setState({
                                    year: str,
                                    data: [],
                                }, () => {
                                    this.getDateData(date)
                                });
                            }}
                        >
                            {dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 200 }}
                            value={this.state.date}
                            onChange={(str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getDateData(str)
                            }}
                        >
                            <Option value="1">Q1 第一季度</Option>
                            <Option value="2">Q2 第二季度</Option>
                            <Option value="3">Q3 第三季度</Option>
                            <Option value="4">Q4 第四季度</Option>
                        </Select>
                        <Button
                            type="primary"
                            style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                            onClick={this.getDateData.bind(this, this.state.date, true)}
                        >填充上季度数据</Button>
                    </Row>
                    <Table
                        columns={columns}
                        dataSource={data}
                        size="middle"
                        className="content"
                        bordered
                        loading={loading}
                        id="table4"
                        pagination={false}
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => {
                            return index
                        }}
                    />
                </Row>

                <Row className="table-footer-btn">
                    {getJson(['auth', 'user', 'email'], this.props.store, '').includes('admin') && < Button
                        type="primary"
                        style={{ marginRight: 10 }}
                        onClick={() => {
                            this.setState({ loading: true }, () => {
                                this.downloadSave();
                            });
                        }}
                        loading={this.state.print}
                    >导出酒店保存情况</Button>}
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={this.state.print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_4_1">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={this.state.print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div >
        );
    }
}

export default index; 


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-2.js